import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import { useSelector, useDispatch } from "react-redux";
import { getAllNotificationAction } from "../../../store/actions/notification/NotificationActions";
import moment from "moment-timezone";
import Styles from "./NotificationList.module.css";
import NoDataFound from "../common/NoDataFound";

const NotificationList = () => {
  const { loading, error, message, notifications, totalCount } = useSelector((state) => state.notification);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const countPerPage = Number(process.env.REACT_APP_ITEMS_PER_PAGE);

  useEffect(() => {
    let payload = {
      page_number: currentPage,
      order_by: "created_at",
      order_direction: "DESC",
    };
    dispatch(getAllNotificationAction(payload, navigate));
  }, [dispatch, currentPage]);

  const convertToIST = (isoDateTime) => {
    const dateTimeInUTC = moment.utc(isoDateTime);
    const dateTimeInIST = dateTimeInUTC.tz("Asia/Kolkata");
    return dateTimeInIST.format("D MMM YYYY, h:mm:ss A");
  };

  const onPageChange = (increment) => {
    setCurrentPage((prevPage) => Math.max(1, prevPage + increment));
  };

  const totalPages = Math.ceil(totalCount / countPerPage);

  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Notifications</Link>
          </li>
        </ol>
      </div>

      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-header'>
              <h4 className='card-title'>Notification</h4>
              <div>
                <Link to={"/create-notification"} className='btn btn-primary me-2'>
                  Create Notification
                </Link>
              </div>
            </div>

            <div className='card-body'>
              <div className='table-responsive ticket-table'>
                <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
                  <div className='table-responsive'>
                    <table id='example' className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Message</th>
                          <th className="text-center">In App Notification</th>
                          <th>Type</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={5} className='text-center'>
                              <ShimmerLoader />
                            </td>
                          </tr>
                        ) : notifications.length > 0 ? (
                          notifications.map((item, index) => (
                            <tr key={index}>
                              <td>{item.header}</td>
                              <td className={`${Styles.wrap_text}`}> {item.message}</td>
                              <td className="text-center"> {item.in_app ? "Yes" : "No"}</td>
                              <td> {item.notification_type ? item.notification_type : "--"}</td>
                              <td>{item.created_at ? convertToIST(item.created_at) : "-"} </td>
                            </tr>
                          ))
                        ) : (
                          <tr className={`${Styles.no_hover}`}>
                            <td className={`fs-3 text-center`} colSpan={9}>
                              <NoDataFound width={450} />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {notifications.length > 0 && (
                    <div className='d-flex justify-content-end align-items-center px-4 py-2'>
                      <div className='d-sm-flex justify-content-end align-items-center ms-3 mt-3 mb-3'>
                        <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center' id='example2_paginate'>
                          <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => currentPage > 1 && onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
                          <span className='mx-2'>
                            Page {currentPage} of {totalPages}
                          </span>
                          <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => currentPage < totalPages && onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationList;
